module.exports = __webpack_public_path__ + "static/media/iq.af0a1cd4.svg";